import { render, staticRenderFns } from "./Comp17t3.vue?vue&type=template&id=1a4b0bd7&scoped=true&"
import script from "./Comp17t3.vue?vue&type=script&lang=js&"
export * from "./Comp17t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp17t3.vue?vue&type=style&index=0&id=1a4b0bd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b0bd7",
  null
  
)

export default component.exports